import {
  mdiClockOutline,
  mdiCheck,
  mdiClose,
  mdiCancel,
  mdiLoading,
  mdiAlertCircleOutline,
} from '@mdi/js';
import { JobStatuses, JobTypes } from 'common/state/jobs/actions';
import { DefaultTheme } from 'styled-components';

export const REFETCH_PERIOD = 10000;

export const RUNNING_JOB_STATUSES = new Set([
  JobStatuses.PENDING,
  JobStatuses.STARTED,
  JobStatuses.CANCELLING,
]);

export const jobStatusPathMap = {
  [JobStatuses.PENDING]: mdiClockOutline,
  [JobStatuses.STARTED]: mdiLoading,
  [JobStatuses.SUCCEEDED]: mdiCheck,
  [JobStatuses.FAILED]: mdiClose,
  [JobStatuses.CANCELLED]: mdiCancel,
  [JobStatuses.CANCELLING]: mdiAlertCircleOutline,
};

export const getJobTypeColour = (
  type: JobTypes,
  _theme: DefaultTheme
): string | null => {
  if (type === JobTypes.DISCOVER) return 'cadetblue';
  if (type === JobTypes.SCRAPE_V2) return 'burlywood';
  if (type === JobTypes.CREDIT_WEEKLY_PL) return 'darkseagreen';
  return undefined;
};

export const getJobStatusColour = (
  status: JobStatuses,
  theme: DefaultTheme
): string | null => {
  if (status === JobStatuses.PENDING) return theme.warning;
  if (status === JobStatuses.STARTED) return theme.warning;
  if (status === JobStatuses.SUCCEEDED) return theme.primary;
  if (status === JobStatuses.FAILED) return theme.danger;
  if (status === JobStatuses.CANCELLED) return theme.danger;
  if (status === JobStatuses.CANCELLING) return theme.warning;
  return undefined;
};
